import { Backend } from '../../api/Backend';
import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { CustomerSettingsKeys } from '../../api/models/CustomerSettingsKeys';

export class AutoplayHelper {
  private static _autoplayEnabled = false;
  private static _autoplayPercent = 0.95;
  private static _autoplayMaxAmount = 5;

  public static checkAutoplayEnabled(backend: Backend) {
    const autoPlayEnabled = backend.globalSettings.boolValue(GlobalSettingsKeys.autoplayWatchingEnabledVod) || false;
    backend.cachedCustomerSettings
      .getSetting(backend, CustomerSettingsKeys.autoplay_enabled)
      .then(r => {
        if (r && r.value === 'true') {
          this._autoplayEnabled = autoPlayEnabled && true;
        } else {
          this._autoplayEnabled = false;
        }
      })
      .catch(() => {
        this._autoplayEnabled = autoPlayEnabled;
      });
    this._autoplayPercent =
      backend.globalSettings.numberValue(GlobalSettingsKeys.autoplayNextAssetInDetailPercent) || 0.95;
    this._autoplayMaxAmount = backend.globalSettings.numberValue(GlobalSettingsKeys.autoplayMaxAssetsAutoStart) || 5;
  }

  public static get autoplayEnabled() {
    // return true; // add this for debugging
    return this._autoplayEnabled;
  }

  public static get autoplayPercent() {
    return this._autoplayPercent;
  }

  public static get autoplayMaxAssetsAutoStart() {
    return this._autoplayMaxAmount;
  }
}
